import React from 'react';

const ThemesContext = React.createContext({
  theme: null,
});

ThemesContext.displayName = 'ThemesContext';

export default ThemesContext;
